module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-1-photo-12-ba7ee3ee282c11dab77631cd879625fd.webp";